<template lang="pug">
  v-navigation-drawer(
    app
    v-model="model"
    right
    eager
    :touchless="touchless"
    temporary
    v-glass="{ alphaValue: .85, root: true, blur: 8 }")
      v-sheet.no-radius(
        data-glass
        :color="theme.background.color"
        style="border-top-left-radius: 0; border-top-right-radius: 0"
        height="20%")
      v-row.align-end.ma-0(
        data-glass
        style="height: 80%")
        template(v-if="blockingDrawer")
          v-col
            v-subheader(v-if="blockingDrawer.title") {{ blockingDrawer.title }}
            v-list(v-if="blockingDrawer.items")
              utility-action-state(
                v-for="({ label, icon, onClick }, index) in blockingDrawer.items"
                :key="index"
                :action="onClick")
                template(#default="{ loading, trigger }")
                  v-list-item(
                    @click="trigger"
                    :disabled="loading")
                    v-list-item-icon
                      v-progress-circular(
                        v-if="loading"
                        :size="24"
                        :width="2"
                        indeterminate)
                      v-icon(v-else) {{ icon }}
                    v-list-item-content {{ label }}
          v-col.text-center.text-body-2(:cols="12") Version {{ blockingDrawer.version }}
          v-col.text-center(:cols="12")
            utility-action-state(
              :action="blockingDrawer.itemBottom.onClick")
              template(#default="{ loading, trigger }")
                v-btn(
                  v-if="blockingDrawer.itemBottom"
                  @click="trigger"
                  :loading="loading"
                  :disabled="loading"
                  text
                  blocking)
                  v-icon(left) {{ blockingDrawer.itemBottom.icon }}
                  | {{ blockingDrawer.itemBottom.label }}
</template>

<script>
import { state } from '..'
import { toRefs, watch } from '@vue/composition-api'
import { theme } from '@iez/core'

import UtilityActionState from '@iez/components/utility/action-state'

export default {
  components: {
    UtilityActionState
  },

  setup () {
    watch(
      () => state.model,
      model => {
        if (!model) {
          state.blockingDrawer.onClose()
        }
      }
    )

    return {
      ...toRefs(state),
      theme
    }
  }
}
</script>
